export default "__VITE_ASSET__e4f89db9__"